/**
 * External dependencies
 */
import { useState, useEffect } from "react";

/**
 * Internal dependencies
 */
import { useUrlParams } from "./use-url-params";

export function useUrlParamState(initialValue = null, key = null) {
	const [param, setParam] = useUrlParams(key, initialValue);
	const [value, setValue] = useState(param);

	useEffect(() => {
		setParam(value);
	}, [value]);

	return [value, setValue];
}
